module.exports = __webpack_public_path__ + "a874ecd48fab79039d4391e0ad09e5e7.png";